import {ExperimentNames, getEventId, getEventTitle} from '@wix/wix-events-commons-statics'
import {ChevronDown} from '@wix/wix-ui-icons-common'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {getEventDateInformation, isMultiDay} from '../../../../../../../../../../commons/selectors/event'
import {useWidgetActions, useWidgetState} from '../../../../../../../hooks/state-provider'
import {getSelectedDate, getSelectedEventId} from '../../../../../../../selectors/calendar-layout'
import {getMultiDayText} from '../../../../../../../selectors/events'
import sc from '../../../../../../classes.scss'
import {MobileMonthlyEventDetails} from './details'
import {MobileMonthlyEventProps} from './interfaces'
import s from './mobile-monthly-event.scss'

export const MobileMonthlyEvent = ({event, currentDate}: MobileMonthlyEventProps) => {
  const {t} = useTranslation()
  const {openMonthlyCalendarEvent} = useWidgetActions()
  const {experiments} = useExperiments()

  const eventId = getEventId(event)
  const selectedEventId = useWidgetState(getSelectedEventId)
  const selectedDate = useWidgetState(getSelectedDate)
  const multiDay = useWidgetState(state => isMultiDay(state, event))
  const multiDayText = useWidgetState(state => getMultiDayText(state, eventId, currentDate, t))
  const eventTime = useWidgetState(state => getEventDateInformation(state, eventId)).startTime
  const mobileCalendarRewireEnabled = experiments.enabled(ExperimentNames.MobileCalendarRewire)

  const openEventDetails = () => {
    openMonthlyCalendarEvent({eventId, selectedDate: currentDate})
  }

  return selectedEventId === eventId && currentDate === selectedDate ? (
    <MobileMonthlyEventDetails event={event} />
  ) : (
    <div
      data-hook={`event-${eventId}`}
      className={classNames(s.container, sc.textLineHeight, {
        [s.calendar]: !mobileCalendarRewireEnabled,
        [s.rewire]: mobileCalendarRewireEnabled,
      })}
      onClick={openEventDetails}
    >
      <div data-hook={`event-time-${eventId}`} className={s.time}>
        {multiDay ? multiDayText : eventTime}
      </div>
      <div data-hook={`event-title-${eventId}`} className={s.title}>
        {getEventTitle(event)}
        <div className={s.chevron}>
          <ChevronDown size="1.2em" />
        </div>
      </div>
    </div>
  )
}
